export default __webpack_public_path__ + "static/media/five.da88c8df.jpg";